export class Calender {
  
   date:Date;
   tithi:any ;
   shraddatithi:any ;
   maasa:any;
   paksha:any;
   samvatsara:any;
   //for local usage
   week_day:any;
   month: string;
   year:number;
   constructor()
   {
    //    this.Month = "November";
    //    this.Date = 30;
    //    this.Tithi = "Padya";
    //    this.Shraddha_Tithi = 11;
    //    this.Masa ="Karthika" ;
   }

}


// WEBPACK FOOTER //
// ./src/models/Calander.ts